module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-120x120-a544b7042b8a44a41d1dbef459e84fee.png";